export default {
  common: {
    search: 'Search',
    sortByDate: 'Sort by date',
    sortByUrl: 'Sort by URL',
    noResults: 'No results found for',
    success: 'Operation successful',
    error: 'An error occurred',
    copied: '{{type}} copied to clipboard',
    copyError: 'Failed to copy to clipboard',
    user: 'User',
    showMore: 'Show more {{count}}',
    showLess: 'Show less',
    backToDashboard: 'View Dashboard',
    optional: 'optional'
  },
  notifications: {
    title: 'Notifications',
    clearAll: 'Clear all',
    empty: 'No notifications',
    newUpdate: {
      title: 'New Theme Update Available',
      message: 'Version {{version}} is now available with new features and improvements.',
      action: 'Update Now'
    },
    license: {
      activated: {
        title: 'License Activated',
        message: 'Your license has been successfully activated.',
        action: 'View Dashboard'
      },
      deactivated: {
        title: 'License Deactivated',
        message: 'License for {{url}} has been successfully deactivated.',
        action: 'Activate New License'
      },
      error: {
        title: 'Activation Failed',
        message: 'Failed to activate license. Please check your credentials.',
        action: 'Try Again'
      },
      deactivationError: {
        title: 'Deactivation Failed',
        message: 'Failed to deactivate license. Please try again.',
        action: 'Contact Support'
      }
    },
    auth: {
      error: {
        title: 'Authentication Error',
        message: 'User email not found. Please sign in again.',
        action: 'Sign In'
      }
    },
    validation: {
      invalidUrl: {
        title: 'Invalid URL Format',
        message: 'Please enter a valid Shopify store URL.'
      },
      invalidToken: {
        title: 'Invalid Token Format',
        message: 'Access token must start with "shpat_".'
      }
    }
  },
  auth: {
    login: {
      title: 'Sign in to your account',
      email: 'Email address',
      password: 'Password',
      submit: 'Sign in',
      forgotPassword: 'Forgot your password?',
      noAccount: "Don't have an account?",
      register: 'Register now',
      success: 'Successfully signed in',
      rememberMe: 'Remember me',
      submitting: 'Signing in...',
      error: {
        invalid: 'Invalid email or password',
        generic: 'An error occurred during sign in',
        blocked: 'Account temporarily blocked. Please try again in {{minutes}} minutes.',
        temporarilyBlocked: 'Account temporarily blocked',
        tryAgainIn: 'Try again in:'
      }
    },
    register: {
      title: 'Create your account',
      name: 'Full name',
      email: 'Email address',
      password: 'Password',
      confirmPassword: 'Confirm password',
      submit: 'Create account',
      haveAccount: 'Already have an account?',
      signIn: 'Sign in',
      success: 'Account created successfully',
      submitting: 'Creating account...',
      error: {
        passwordMismatch: 'Passwords do not match',
        emailInUse: 'Email already in use',
        weak: 'Password is too weak',
        generic: 'An error occurred during registration'
      }
    },
    forgotPassword: {
      title: 'Reset your password',
      subtitle: 'Enter your email address to receive a reset link',
      email: 'Email address',
      emailPlaceholder: 'Enter your email',
      submit: 'Send reset link',
      backToLogin: 'Back to login',
      success: 'Reset email sent',
      checkEmail: 'Check your inbox for the reset link',
      error: {
        notFound: 'No account found with this email',
        generic: 'An error occurred. Please try again.'
      }
    },
    logout: {
      button: 'Sign out',
      success: 'Successfully signed out',
      error: 'Error signing out'
    }
  },
  nav: {
    dashboard: 'Dashboard',
    firststeps: 'First steps',
    services: 'Services',
    changelog: 'News',
    activate: 'Activate',
    deactivate: 'Deactivate',
    update: 'Update',
    profile: 'Profile',
    resources: 'Resources',
    ticket: 'Create a Ticket',
    reviewguide: 'Review guide',
    preferences: 'Preferences',
    download: 'Download',
    installTheme: 'Install thème',
    buyLicense: 'Buy License',
    documentation: 'Documentation',
    sections: {
      main: 'Main',
      licenses: 'License Management',
      admin: 'Administration'
    },
    admin: {
      notifications: 'Notifications',
      licensesList: 'Licenses List',
      usersList: 'Users List',
      createLicense: 'Create License',
      activateLicense: 'Activate License',
      deactivateLicense: 'Deactivate License',
      removeLicense: 'Delete License'
    }
  },
  dashboard: {
    title: 'Dashboard',
    greeting: 'Hello, {{name}}',
    welcome: 'Welcome to your Shopiweb Premium license management space',
    reviewguide: 'Review guide',
    stats: {
      authorized: {
        label: 'Authorized Licenses',
        purchased: 'purchased licenses',
        period: 'Manage your Premium licenses',
        description: 'Total number of premium licenses authorized'
      },
      available: {
        label: 'Available Licenses',
        remaining: 'remaining licenses',
        period: 'Ready for activation',
        description: 'Licenses available for new stores'
      },
      installed: {
        label: 'Installed Licenses',
        period: 'Currently in use',
        description: 'Licenses currently active in your stores'
      }
    },
    shopifyUrls: {
      title: 'Active Shopify URLs',
      status: {
        active: 'Active',
        inactive: 'Inactive',
        pending: 'Pending'
      },
      lastActivity: 'Last Activity',
      plan: 'Plan',
      credentials: {
        show: 'Show Credentials',
        hide: 'Hide Credentials',
        accessToken: 'Access Token',
        apiSecret: 'API Secret Key'
      }
    },
    licenseStatus: {
      title: 'License Status',
      subtitle: 'Real-time license availability',
      active: 'Active',
      available: 'Available',
      licenses: 'licenses',
      utilization: 'Utilization',
      unusedLicenses: 'unused licenses available',
      readyForInstallation: 'Ready for new installations',
      activateNew: 'Activate New License',
      purchaseNew: 'Purchase New License',
      noLicensesAvailable: 'You have no licenses available!',
      purchaseOrDeactivate: 'To install a new one, please purchase one or deactivate an existing license.'
    }
  },
  loyalty: {
    program: 'Loyalty Program',
    learnMore: 'Learn more about credits',
    availablePoints: 'available points',
    estimatedValue: 'Estimated value: {{value}}',
    usePoints: 'Use my points',
    info: {
      pointValue: '• 1 point = €0.05',
      earnPoints: '• Points earned with Premium license purchases',
      usePoints: '• Can be used for Shopiweb products and services'
    },
    modal: {
      title: 'Use my points',
      pointsToUse: 'Points to use',
      pointsRequired: 'Points required',
      availablePoints: 'Available points: {{points}}',
      estimatedValue: 'Estimated value: {{value}}',
      warning: 'Your request will be processed within 24-48 business hours.',
      continue: 'Continue',
      cancel: 'Cancel',
      processing: 'Processing...',
      requestSent: 'Your request for {{points}} points has been successfully sent. You have {{remaining}} points remaining.',
      validation: {
        acceptRequired: 'Please accept the terms of use before downloading.',
        insufficientPoints: 'You don\'t have enough points available.',
        invalidAmount: 'Please enter a valid number of points.'
      }
    }
  },
  activate: {
    title: 'Shopiweb Premium License Activation',
    subtitle: 'Enter the information below to activate your license on the Shopify store of your choice.',
    success: 'License successfully activated!',
    error: {
      invalidCredentials: 'The provided credentials are incorrect. Please check your information and try again.'
    },
    form: {
      email: {
        label: 'Email address',
        placeholder: 'Enter your email address',
        help: 'Email used when purchasing the license'
      },
      shopifyUrl: {
        label: 'Shopify store URL',
        placeholder: 'yourstore.myshopify.com',
        help: 'Exact URL of the store where the license should be activated'
      },
      apiKey: {
        label: 'API secret key',
        placeholder: '57d4d708e2efa858df6f93d1799506de',
        help: 'Available in the "API Credentials" section of your Shopiweb Manager account'
      },
      accessToken: {
        label: 'API access token',
        placeholder: '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',
        help: 'Generated in the "API Credentials" section of your Shopify admin'
      },
      validation: {
        invalidUrl: 'Invalid Shopify URL format',
        invalidToken: 'Access token must start with "shpat_"'
      },
      submit: 'Activate license',
      submitting: 'Activating...'
    }
  },
  deactivate: {
    title: 'Shopiweb Premium License Deactivation',
    subtitle: 'Deactivate the Shopiweb Premium license from your Shopify store.',
    success: 'License successfully deactivated.',
    error: 'Failed to deactivate the license. Please try again.',
    notFound: 'No active license found for this store.',
    warning: 'Deactivating your license will immediately revoke access to all Premium features. This action is irreversible.',
    form: {
      shopifyUrl: {
        label: 'Store URL',
        placeholder: 'yourstore.myshopify.com',
        help: 'Enter the exact URL of your Shopify store, or select it from the list.'
      },
      apiKey: {
        label: 'API Secret Key',
        placeholder: '57d4d708e2efa858df6f93d1799506de',
        help: 'The same API key used when activating the license for this store.'
      },
      submit: 'Deactivate license',
      submitting: 'Deactivating...'
    },
    modal: {
      title: 'Confirm License Deactivation',
      message: 'Are you sure you want to deactivate the license for {{url}}?',
      warning: 'This action is irreversible and will immediately revoke access to Premium features.',
      confirm: 'Yes, Deactivate',
      cancel: 'Cancel'
    }
  },
  update: {
    headerTitle: 'Theme Update',
    headerSubtitle: 'Update your Shopiweb Premium theme to the latest available version.',
    title: 'Update Theme',
    subtitle: 'Access the latest features, performance improvements, and bug fixes with the most recent version of the Shopiweb Premium theme.',
    currentVersion: 'Current Version',
    availableVersion: 'Available Version',
    success: 'Theme updated successfully.',
    successRetrieved: 'Themes retrieved successfully.',
    themesRetrieved: 'Unpublished themes from your store have been successfully retrieved.',
    warning: 'Warning',
    selectTheme: 'Please select a theme to update.',
    selectThemePlaceholder: 'Select a theme',
    error: 'Theme update failed. Please try again.',
    fetchError: 'Failed to retrieve available themes.',
    themeUpdated: 'Don’t forget to refresh your Shopify store page in about 5 minutes to see the changes and enjoy the new version.',
    form: {
      email: {
        label: 'Email address',
        placeholder: 'Enter your email address',
        help: 'Email used when purchasing the license'
      },
      shopifyUrl: {
        label: 'Shopify Store URL',
        placeholder: 'yourstore.myshopify.com',
        help: 'Enter the exact URL of your Shopify store, or select it from the list.'
      },
      apiKey: {
        label: 'API Secret Key',
        placeholder: '57d4d708e2efa858df6f93d1799506de',
        help: 'The same API key used when activating the license for this store.'
      },
      submit: 'Update Theme',
      submitting: 'Updating...',
      loading: 'Loading themes...',
      loadThemes: 'Load available themes'
    },
    modal: {
      title: 'Confirm Theme Update',
      message: 'Are you sure you want to update the theme for {{url}}?',
      confirm: 'Yes, update',
      cancel: 'Cancel'
    }
  },
  download: {
    headerTitle: 'Manual Download (Optional)',
    headerSubtitle: 'Manually download the latest version of the theme if you prefer not to use automatic installation.',
    title: 'Download Shopiweb Premium',
    subtitle: 'The latest stable version of the theme, including all premium features.',
    currentVersion: 'Current Version',
    availableVersion: 'Available Version',
    beforeDownload: {
      title: 'Before downloading (optional)',
      items: [
        'Ensure your license is active',
        'Back up your current theme',
        'Check compatibility with your store'
      ]
    },
    form: {
      termsAccept: 'I accept the',
      termsLink: 'terms of use',
      andRead: 'and I have read the',
      installGuide: 'installation guide',
      downloadButton: 'Download Theme',
      downloadPreparation: 'Preparing download...',
      viewDocumentation: 'View documentation',
      alternativeDownload: 'Try an alternative download method'
    },
    guide: {
      title: 'Quick Installation Guide (Manual)',
      steps: {
        prerequisites: {
          title: 'Requirements',
          description: 'Shopify OS 2.0 required. Theme is compatible with the latest version of Shopify.'
        },
        backup: {
          title: 'Backup your existing theme',
          description: 'Export your current theme from the Shopify admin.'
        },
        installation: {
          title: 'Manual Installation',
          description: 'Upload the ZIP file in your Shopify admin under "Themes".'
        },
        configuration: {
          title: 'Initial Configuration',
          description: 'Adjust the basic theme settings to fit your needs.'
        }
      },
      detailedGuide: 'View full installation guide'
    },
    notifications: {
      downloadStarted: {
        title: 'Download started',
        message: 'The theme has been successfully downloaded.',
        action: 'Open the installation guide'
      },
      error: {
        title: 'Download error',
        message: 'An error occurred during the download. Please try again.',
        action: 'Retry'
      },
      termsRequired: {
        title: 'Terms acceptance required',
        message: 'You must accept the terms of use before downloading the theme.'
      }
    }
  },
  install: {
    title: 'Shopiweb Premium Theme Installation',
    subtitle: 'Quickly and easily install the Shopiweb Premium theme on your Shopify store.',
    success: 'License successfully activated',
    error: {
      invalidCredentials: 'Invalid credentials. Please check your information and try again.'
    },
    form: {
      title: 'Connection Details',
      subtitle: 'Secure connection with automatic detection of your access token to proceed with the theme installation.',
      shopifyUrl: {
        label: 'Store URL',
        placeholder: 'yourstore.myshopify.com',
        help: 'Enter the exact URL of your Shopify store, or select it from the list if available.'
      },
      accessToken: {
        label: 'API Access Token',
        placeholder: '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',
        help: 'Use the same API access token that was used when activating the license for this store.'
      },
      validation: 'Theme successfully installed! Theme ID:',
      titlesubmit: 'Proceed with theme installation',
      subtitlesubmit: 'Click the button below to launch the automatic installation of the Shopiweb Premium theme on your Shopify store.',
      submit: 'Install Theme',
      submitting: 'Installing...',
      newsubmit: 'Install Again'
    }
  },
  profile: {
    title: 'Profile Information',
    subtitle: 'Manage your personal information and security settings',
    personalInfo: 'Personal Information',
    name: 'Name',
    email: 'Email',
    company: 'Company',
    memberSince: 'Member Since',
    save: 'Save Changes',
    saving: 'Saving...',
    updateSuccess: 'Profile updated successfully',
    updateError: 'Failed to update profile',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    changePassword: 'Change Password',
    validation: {
      nameLength: 'Name must be at least 2 characters long',
      currentPasswordRequired: 'Current password is required to change password',
      currentPasswordInvalid: 'Current password is incorrect',
      passwordLength: 'New password must be at least 8 characters long',
      passwordMismatch: 'Passwords do not match'
    },
    image: {
      title: 'Profile Photo',
      upload: 'Upload Photo',
      uploading: 'Uploading...',
      remove: 'Remove Photo',
      preview: 'Profile photo preview',
      requirements: 'JPG, GIF or PNG. Max size 5MB.',
      invalidType: 'Please upload an image file',
      tooLarge: 'Image must be less than 5MB',
      uploadSuccess: 'Profile photo uploaded successfully',
      uploadError: 'Failed to upload profile photo',
      removeSuccess: 'Profile photo removed successfully',
      removeError: 'Failed to remove profile photo',
      loadError: 'Unable to load image',
      processingError: 'Error processing image',
      invalidDimensions: 'Image must be at least 200x200 pixels',
      dragAndDrop: 'Drag and drop your photo here or click to select',
      dropHere: 'Drop your photo here'
    },
    role: {
      admin: 'Administrator',
      user: 'User'
    },
    stats: {
      memberSince: {
        label: 'Member since',
        tooltip: 'Platform registration date'
      },
      activeLicenses: {
        label: 'Active licenses',
        tooltip: 'Number of currently active Premium licenses'
      },
      loyaltyPoints: {
        label: 'Loyalty points',
        tooltip: 'Accumulated points redeemable for discounts',
        value: 'Value: {{amount}}'
      }
    }
  },
  admin: {
    createLicense: {
      title: 'Create Premium License',
      subtitle: 'Create new Premium licenses for your customers',
      success: 'License created successfully'
    },
    deactivateLicense: {
      title: 'Premium License Deactivation',
      subtitle: 'Deactivate new Premium licenses for your clients',
      success: 'License successfully deactivated'
    },
    removeLicense: {
      title: 'Remove Premium License',
      subtitle: 'Remove existing Premium licenses',
      success: 'License removed successfully',
      confirm: 'Are you sure you want to remove this license?'
    }
  }
};